import React from 'react';
import { Form } from 'antd';
import classNames from 'classnames';
import ABSInput from '../../ABSInput';

interface ITextAreaProps {
  form: any;
  label: string;
  required?: boolean;
  id: string;
  validator?: (rule: any, value: any, callback: (msg: string) => any) => any;
  labelWidth: number;
  labelClassName: string;
  placeholder?: string;
  style?: React.CSSProperties;
  height?: number;
  autosize?: boolean;
  onChange?: (value: string) => void;
  className?: string;
  defaultValue?: string;
  initialValue?: string;
  bottomTextClassName?: string;
  disableResize?: boolean;
  type?: 'text' | 'textarea' | 'password';
  areaMaxLen?: number;
}

interface ITextAreaState {
  value: string;
}
export default class TextArea extends React.Component<
  ITextAreaProps,
  ITextAreaState
> {
  render() {
    const {
      form,
      label,
      required,
      id,
      validator,
      labelWidth,
      labelClassName,
      placeholder,
      style,
      height,
      autosize,
      className,
      onChange,
      initialValue,
      bottomTextClassName,
      disableResize,
      areaMaxLen,
      type
    } = this.props;
    const { getFieldDecorator } = form;
    const errorMessage = `请输入${label}`;
    const classes = classNames('internal-message-textarea', className);
    const extraValidator = validator ? { validator } : {};
    return (
      <Form.Item
        label={
          <span
            className={classNames(labelClassName)}
            style={{ width: labelWidth }}
          >
            {label}
          </span>
        }
        colon={false}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
      >
        {getFieldDecorator(id, {
          initialValue,
          rules: [
            { required: required ? required : false, message: errorMessage },
            { ...extraValidator }
          ]
        })(
          <ABSInput
            onChange={onChange}
            placeholder={placeholder}
            className={classes}
            autosize={autosize}
            style={style}
            height={height}
            disabled={false}
            bottomTextClassName={bottomTextClassName}
            disableResize={disableResize}
            type={type}
            defaultValue={initialValue}
            areaMaxLen={areaMaxLen}
          />
        )}
      </Form.Item>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSForm/TextArea/index.tsx